import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import faviconUrl from './assets/favicon.png';
import { applyCroppedFaviconFromImageUrl } from './utils/favicon';

// Load, crop transparent padding, and register favicons so the icon appears larger
applyCroppedFaviconFromImageUrl(faviconUrl);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
